import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PERMISSIONS, ROLES } from "app/constants";
import { RootState } from "app/store";
import {
  changePassword,
  ChangePasswordForm,
  loadProfile,
  ProfileForm,
  updateProfile
} from "../home/my-profile/profileAPI";

export interface ProfileBundle {
  begin: string;
  end: string;
  name: string;
  type: string;
  price: number;
  user_limit: number;
  waiver_limit: number;
  storage_limit: number;
  submit_limit: number;
  location_limit: number;
}

export interface ProfileData {
  id: number;
  party_id: number;
  //auth_key: string;
  created_at: number;
  email: string;
  email_verified: number;
  first_name: string;
  last_name: string;
  file_id: number;
  status: number;
  timezone: null;
  updated_at: number;
  username: string;
  verify_token: null;
  role: ROLES;
  //TODO: Ez igazából nincs is csak a useAccess-hez kell
  permissions?: PERMISSIONS[];
  password: string;
  passwordRepeat: string;
  bundle?: ProfileBundle;
}

export interface ProfileState {
  data: ProfileData;
  status: "idle" | "loading" | "failed";
}

const initialState: ProfileState = {
  data: {} as ProfileData,
  status: "idle",
};

export const loadProfileAsync = createAsyncThunk(
  "profile/load",
  async (_, { rejectWithValue }) => {
    const { data, error, success } = await loadProfile();

    if (success) {
      return data.data;
    }
    return rejectWithValue(error);
  }
);

export const updateProfileAsync = createAsyncThunk(
  "profile/update",
  async (item: ProfileForm, { rejectWithValue }) => {
    const { data, error, success } = await updateProfile(item);
    if (success) {
      return data.data;
    }
    return rejectWithValue(error);
  }
);

export const changePasswordAsync = createAsyncThunk(
  "profile/change-password",
  async (item: ChangePasswordForm, { rejectWithValue }) => {
    const { data, error, success } = await changePassword(item);
    if (success) {
      return data.data;
    }
    return rejectWithValue(error);
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: state => {
      state.data = {} as ProfileData;
    },
    resetStatus: state => {
      state.status = "idle";
    },
  },
  extraReducers: builder => {
    //Load profile
    builder
      .addCase(loadProfileAsync.pending, state => {
        state.status = "loading";
      })
      .addCase(loadProfileAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      });
    //Update profile
    builder
      .addCase(updateProfileAsync.pending, state => {
        state.status = "loading";
      })
      .addCase(updateProfileAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      });
  },
});

export const { clearProfile, resetStatus } = profileSlice.actions;

export const selectProfile = (state: RootState) => state.profile.data;
export const selectProfileStatus = (state: RootState) => state.profile.status;
export const selectProfilePermissions = (state: RootState) =>
  state.profile.data.permissions;
export const selectProfileRole = (state: RootState) => state.profile.data.role;
export default profileSlice.reducer;
